import { put, select, takeLatest } from 'redux-saga/effects'
import { ExposureConstants } from '../store/exposure.constants'
import { setExposureList } from '../store/exposure.actions'
import { IExposureState } from '../store/exposure.types'
import { getExposureSelector } from '../selectors/getExposure.selector'
import { initialExposure } from '../store/exposure.reducers'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setSuspectedExposure() {
  const exposureState: IExposureState = yield select(getExposureSelector)
  const { suspectedExposure, suspectedExposurePNNV, exposureList, crewId } = exposureState
  const selectedExposure = exposureList.find((exp) => exp.crewId === crewId)
  try {
    if (selectedExposure) {
      selectedExposure.suspectedExposure = suspectedExposure
      selectedExposure.suspectedExposurePNNV = suspectedExposurePNNV

      yield put(setExposureList(exposureList))
    } else {
      const copyExposureList = [
        ...exposureList,
        {
          ...initialExposure,
          crewId,
          suspectedExposure,
          suspectedExposurePNNV,
        },
      ]
      yield put(setExposureList(copyExposureList))
    }
  } catch (e) {
    yield put(throwPcrException(`setSuspectedExposure() error: ${e}`))
  }
}
export function* setSuspectedExposureSaga() {
  yield takeLatest(
    [ExposureConstants.SET_SUSPECTED_EXPOSURE, ExposureConstants.SET_SUSPECTED_EXPOSURE_PNNV],
    setSuspectedExposure
  )
}
